import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { handleModal } from '../../redux/actions/modals';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
import { APP_INFO_PARAMS, APPLICATION_TYPE, ORDER_TYPES, WATCHLIST_GRID_INDEX, EXCHANGE_NAME_LIVEPULSE, MARKET_SEGMENT_ID } from '../../utils/global_variables';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
import { calculateCVF, getAppInfoData, getDyanmicURL, getProductTypeValue } from '../../utils/global_functions';
import { Col, Container, Row } from 'react-bootstrap';
import { getOrderMarginInfo } from '../../redux/actions/orders';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End


const BrokerageCharges = ({ brokerageParams, orderEntryTab, activeTabKey, }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
    const multiLegData = useSelector(state => state.orders.multiLegDataForBrokerage);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);
    const spreadOrderArr = useSelector(state => state.orders.spreadOrderInfo);
    const objSpreadInfoBrokerage = useSelector(state => state.orders.objSpreadInfoBrokerage);
    const { scripOrderInfo } = useMemo(() => ({ scripOrderInfo: objScripOrderInfo?.scripData }), [objScripOrderInfo]);
    const [brokerageUrl, setBrokerageUrl] = useState('');
    const objBrokerage = useMemo(() => {
        const objBrokerageData = getAppInfoData(APP_INFO_PARAMS.APP_BROKERAGE_MODE);
        return objBrokerageData ?? '';
    }, []);

    useEffect(() => {
        //24-07-2025 --Ameersha N Based on orderEntryTab value and active tab key ordermargininfo will be handleded --Start
        switch (orderEntryTab) {
            case ORDER_TYPES.SINGLE_SCRIP:
                const arrLegDetails = [
                    {
                        "LegNo": 1,
                        "BuyOrSell": brokerageParams?.transactiontype,
                        "MarketSegmentId": scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                        "Token": scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                        "Quantity": brokerageParams.quantity,
                        "Price": Math.round(brokerageParams?.price * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                        "MktFlag": brokerageParams?.mktType?.includes('MKT') ? 1 : 0,
                        "OldPrice": 0,
                        "OldQuantity": 0,
                        "ProductType": getProductTypeValue(brokerageParams?.producttype),
                        "LegIndicator": 0
                    }
                ];
                dispatch(getOrderMarginInfo(arrLegDetails));
                break;
            case ORDER_TYPES.MULTI_SCRIP:
                if (activeTabKey === ORDER_TYPES.MULTI_LEG) {
                    //Deepti B. SAT 6909: 28-08-2025: for commodity scrips(NSE_COMM, BSE_COMM, NSE_CURR, BSE_CURR) sending lot count as a quantity in multileg
                    let arrPayload = multiLegData?.map((item) => {
                        let nQuantity = item?.ask_qty * item?.count;
                        if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                            nQuantity = item?.ask_qty * item?.count;
                        } else {
                            nQuantity = item?.count;
                        }
                        return {
                            "LegNo": item?.legNumber,
                            "BuyOrSell": item?.activeButtonToggleIndex + 1,
                            "MarketSegmentId": item?.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                            "Token": item?.token,
                            "Quantity": nQuantity,
                            "Price": Math.round(item?.legPrice * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                            "MktFlag": item?.orderType?.includes('MKT') ? 1 : 0,
                            "OldPrice": 0,
                            "OldQuantity": 0,
                            "ProductType": "D",
                            "LegIndicator": 5,
                        };
                    });
                    dispatch(getOrderMarginInfo(arrPayload));
                } else if (activeTabKey === ORDER_TYPES.SPREAD) {
                    let arrPayload = objSpreadInfoBrokerage?.buyAndSellScrip?.map((item, index) => {
                       // Deepti B. SAT 6909: 26/08/2025: for spread order, will consider first leg ltp price for both bue and sell scrip
                        const price = parseFloat(objSpreadInfoBrokerage?.objLegsLtps[`${objSpreadInfoBrokerage?.spreadOrderInfo?.exchangeNo + '_' + objSpreadInfoBrokerage?.buyAndSellScrip[0]?.nToken}`]?.ltp ?? objSpreadInfoBrokerage?.objLegsLtps[`${objSpreadInfoBrokerage?.spreadOrderInfo?.exchangeNo + '_' + objSpreadInfoBrokerage?.buyAndSellScrip[0]?.nToken}`]) * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]
                        const priceDifference = objSpreadInfoBrokerage?.spreadOrderInfo?.amount * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]
                        return {
                            "LegNo": index + 1,
                            "BuyOrSell": item?.buySellType === 'SELL' ? 2 : 1,
                            "MarketSegmentId": objSpreadInfoBrokerage?.spreadOrderInfo?.exchangeNo,
                            "Token": item?.nToken,
                            "Quantity": item?.nRegularLot,
                            // Deepti B. SAT 6909: 26/08/2025: price calculation depends on order type
                            "Price": objSpreadInfoBrokerage?.spreadOrderInfo?.orderType?.includes('MKT') ? price : index === 0 ? price : price + priceDifference,
                            "MktFlag": objSpreadInfoBrokerage?.spreadOrderInfo?.orderType?.includes('MKT') ? 1 : 0,
                            "OldPrice": 0,
                            "OldQuantity": 0,
                            "ProductType": "D",
                            "LegIndicator": 5, // Deepti B. SAT 6909: 18/08/2025: Updated leg indicator from 0 to 5
                            "UserId": objLoginSession?.data?.user_id,
                        };
                    });
                    dispatch(getOrderMarginInfo(arrPayload));
                }

                break;
            default:
                break;
        }
        //24-07-2025 --Ameersha N Based on orderEntryTab value and active tab key ordermargininfo will be handleded --End
    }, [brokerageParams, objSpreadInfoBrokerage, dispatch, multiLegData, orderEntryTab, scripOrderInfo, spreadOrderArr, activeTabKey]);




    //PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
    const showBrokerage = useCallback((objBrokerageData) => {
        try {
            //24-07-2025 --Ameersha N Based on orderEntryTab value and active tab key params will be formed for brokerage and url will be used and  will be handleded --Start
            //Vaibhav Singh : BT-106776 - 08-11-2023-  MarginData removed from here - Start
            if (objBrokerageData?.url && scripOrderInfo?.length && Object.keys(brokerageParams)?.length) {
                //Vaibhav Singh : BT-106776 - 08-11-2023-  MarginData removed from here - End
                // Vinit Raut 25-04-2024 : BT-106776_Breeze-Breeze - Display Brokerage and statutory charge -- Start
                const priceLocatorObj = {
                    price_num: scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR],
                    price_den: scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR],
                    gen_num: scripOrderInfo[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN],
                    gen_den: scripOrderInfo[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN],
                    market_lot: scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT],
                    preferred_mktSegId: String(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                    quantity: brokerageParams.quantity
                };
                switch (orderEntryTab) {
                    case ORDER_TYPES.SINGLE_SCRIP:
                        const params = {
                            ...brokerageParams,
                            url: objBrokerageData?.url,
                            type: objBrokerageData.encryptiontype || 1,
                            mktsegid: scripOrderInfo[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                            series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                            //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: start
                            brokerage: parseFloat(arrMarginInfo?.Brokerage) || 0.00,
                            //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: End
                            legIndicator: 1,
                            theme: "L",
                            instrument: scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT],
                            priceLocator: calculateCVF(priceLocatorObj)
                        };
                        // Vinit Raut 25-04-2024 : BT-106776_Breeze-Breeze - Display Brokerage and statutory charge -- End
                        //BT-107437: Functional Implementation InvestMents : Vaibhav Singh : 21-08-2023 : Implemented Value for Dyanamic URl
                        setBrokerageUrl(getDyanmicURL(params, objLoginSession));
                        break;

                    case ORDER_TYPES.MULTI_SCRIP:
                        if (activeTabKey === ORDER_TYPES.MULTI_LEG) {
                            let LegDtls = [];
                            for (let i = 0; i < multiLegData?.length; i++) {
                                let nQuantity = multiLegData[i]?.ask_qty * multiLegData[i]?.count;
                                if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                                    nQuantity = multiLegData[i]?.ask_qty * multiLegData[i]?.count;
                                } else {
                                    nQuantity = multiLegData[i]?.count;
                                }
                                let jData_legDtls = {};
                                jData_legDtls["LegIndicator"] = multiLegData.length === 2 ? 5 : 6; // 2leg=5, 3leg=6 , spread=4
                                jData_legDtls["MarketSegmentId"] =
                                    multiLegData[i]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID];
                                jData_legDtls["Series"] = "XX";
                                jData_legDtls["ProductType"] = "CARRYFORWARD";
                                jData_legDtls["TransactionType"] = 1;
                                jData_legDtls["Quantity"] = nQuantity;
                                jData_legDtls["Price"] = multiLegData[i]?.legPrice;
                                jData_legDtls["Instrument"] = multiLegData[i].instrument;
                                jData_legDtls["PriceLocator"] = calculateCVF(priceLocatorObj);
                                LegDtls.push(jData_legDtls);
                            };


                            let params1 = {
                                Product: APPLICATION_TYPE,
                                Theme: "L",
                                UserId: objLoginSession?.data?.user_id,
                                GroupId: objLoginSession?.data?.others?.groupId,
                                SessionId: objLoginSession?.data?.others?.ocToken,
                                mktsegid: multiLegData[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                                series: "XX",
                                ProductType: "CARRYFORWARD",
                                TransactionType: 1,
                                //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: start
                                Brokerage: arrMarginInfo?.Brokerage ?? 0.0,
                                //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: End
                                LegDetails: JSON?.stringify(LegDtls),
                            };
                            setBrokerageUrl(getDyanmicURL(params1, objLoginSession));
                            let form = document.createElement("form");
                            form?.setAttribute("name", "brokerageForm");
                            form?.setAttribute("method", "post");
                            form?.setAttribute(
                                "action",
                                `${objBrokerage?.url?.split('?')[0]}`
                            );

                            for (let i in params1) {
                                if (params1.hasOwnProperty(i)) {
                                    let brokerageField = document.createElement("input");
                                    brokerageField.type = "hidden";
                                    brokerageField.name = i;
                                    brokerageField.value = params1[i];
                                    form?.appendChild(brokerageField);
                                }
                            }
                            form?.setAttribute("target", "TargetFrame");
                            document.body.appendChild(form);
                            document?.forms["brokerageForm"]?.submit();
                            document?.forms["brokerageForm"]?.remove();
                            break;
                        } else if (activeTabKey === ORDER_TYPES.SPREAD) {
                            let LegDtls = [];
                            let price = parseFloat(objSpreadInfoBrokerage?.objLegsLtps[`${objSpreadInfoBrokerage?.spreadOrderInfo?.exchangeNo + '_' + objSpreadInfoBrokerage?.buyAndSellScrip[0]?.nToken}`]?.ltp ?? objSpreadInfoBrokerage?.objLegsLtps[`${objSpreadInfoBrokerage?.spreadOrderInfo?.exchangeNo + '_' + objSpreadInfoBrokerage?.buyAndSellScrip[0]?.nToken}`])
                            let priceDifference = parseFloat(objSpreadInfoBrokerage?.spreadOrderInfo?.amount) 
                            for (let i = 0; i < objSpreadInfoBrokerage?.buyAndSellScrip?.length; i++) {
                                let jData_legDtls = {};
                                jData_legDtls["LegIndicator"] = 5; // 2leg=5, 3leg=6 , spread=4
                                jData_legDtls["MarketSegmentId"] = scripOrderInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID];

                                jData_legDtls["Series"] = "XX";
                                jData_legDtls["ProductType"] = "CARRYFORWARD";
                                jData_legDtls["TransactionType"] = i + 1;
                                jData_legDtls["Quantity"] = objSpreadInfoBrokerage?.buyAndSellScrip[i]?.nRegularLot;
                              // Deepti B. SAT 6909: 26/08/2025: price calculation depends on order type
                                jData_legDtls["Price"] = objSpreadInfoBrokerage?.spreadOrderInfo?.orderType?.includes('MKT') ? price : i === 0 ? price : price + priceDifference;
                                jData_legDtls["Instrument"] = objSpreadInfoBrokerage?.buyAndSellScrip[i].sInstrumentName;
                                jData_legDtls["PriceLocator"] = calculateCVF(priceLocatorObj);
                                LegDtls.push(jData_legDtls);
                            }

                            let params1 = {
                                Product: APPLICATION_TYPE,
                                Theme: "L",
                                UserId: objLoginSession?.data?.user_id,
                                GroupId: objLoginSession?.data?.others?.groupId,
                                SessionId: objLoginSession?.data?.others?.ocToken,
                                mktsegid: objSpreadInfoBrokerage?.spreadOrderInfo?.exchangeNo,
                                series: "XX",
                                ProductType: "CARRYFORWARD",
                                Brokerage: arrMarginInfo?.Brokerage ?? 0.0,
                                LegDetails: JSON?.stringify(LegDtls),
                            };
                            setBrokerageUrl(getDyanmicURL(params1, objLoginSession));
                            let form = document.createElement("form");
                            form?.setAttribute("name", "brokerageForm");
                            form?.setAttribute("method", "post");
                            form?.setAttribute(
                                "action",
                                `${objBrokerage?.url?.split('?')[0]}`
                            );

                            for (let i in params1) {
                                if (params1.hasOwnProperty(i)) {
                                    let brokerageField = document.createElement("input");
                                    brokerageField.type = "hidden";
                                    brokerageField.name = i;
                                    brokerageField.value = params1[i];
                                    form?.appendChild(brokerageField);
                                }
                            }
                            form?.setAttribute("target", "TargetFrame");
                            document.body.appendChild(form);
                            document?.forms["brokerageForm"]?.submit();
                            document?.forms["brokerageForm"]?.remove();
                            break;
                        }
                    default:
                        break;
                }
                //24-07-2025 --Ameersha N Based on orderEntryTab value and active tab key params will be formed for brokerage and url will be used and  will be handleded --End
            }
        } catch (error) {
            console.error(error);
        }
    }, [scripOrderInfo, objSpreadInfoBrokerage, arrMarginInfo, objLoginSession, orderEntryTab, brokerageParams, objBrokerage, activeTabKey, multiLegData]);



    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
    useEffect(() => {
        const objBrokerageData = getAppInfoData(APP_INFO_PARAMS.APP_BROKERAGE_MODE);
        showBrokerage(objBrokerageData);
    }, [showBrokerage]);
    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End


    const onHide = () => {
        dispatch(handleModal([{ "BROKERAGE_CHARGES_MODAL": false }]));
    };

    return (
        <Container fluid className='p-0'>
            <BzModal data-testid="brokerage-charges-modal" show={modals['BROKERAGE_CHARGES_MODAL']} onHide={onHide} centered>
                <BzModalHeader className='modaltabs-header modal-header' >
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <div data-testid="header-brokerage-modal-title" className='font-medium font-size4 color-text'>Brokerage and Charges</div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div data-testid="header-brokerage-modal-close-icon" className='icon-16 icon-dark icon-close' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <iframe name='TargetFrame' src={brokerageUrl} height='600px' width='100%' title='Brokerage Charges' />
                </BzModalBody>
            </BzModal>
        </Container>
    );
};

export default memo(BrokerageCharges);